import http from "@/common/http.service";

const ADD_PAYMENT_CARD = "payment/addcard";
const NUMBER_VALIDATION = "payment/cardnumbervalidate";
const LIST_URL = "payment/list";
const EDIT_URL = "payment/fetchdata";
const SET_DEFAULT = "payment/setDefault";
const DELETE_CARD = "payment/deletecard";
const DEFAULT_CARD = "payment/getdefaultcard";
const PAY_URL = "payment/pay";
const EXPIRE_URL = "payment/lastpaymnet";
const GET_CLIENTPALN = "account/plan";
const SAVE_LAST_SELECTED_PLAN = "client-plan/select";
const GET_LAST_SELECTED_PLAN = "client-plan/checkout";
const APPLY_COUPON_CODE = "client-plan/coupon/apply";
const CANCEL_SUBSCRIPTION = "client-plan/cancel-subscription";
const CURRENT_PLAN_DETAILS = "current-plandetails";
const NEW_AUTH_TOKEN = "client-plan/new-auth";
const RESTART_SUBSCRIPTION = "client-plan/restart-subscription";
const GET_SAVED_CARDS = "client-plan/saved-cards";

export default {
  addPaymentCard(params) {
    return http.post(ADD_PAYMENT_CARD, params);
  },
  payMethod(params) {
    return http.post(PAY_URL, params);
  },
  cardnumberValidate(params) {
    return http.post(NUMBER_VALIDATION, params);
  },
  paymentDetails(params, cb) {
    http.post(LIST_URL, params).then(function (response) {
      cb(response.data);
    });
  },
  fetOneCardDetails(params) {
    return http.post(EDIT_URL, params);
  },
  setDefault(params) {
    return http.post(SET_DEFAULT, params);
  },
  deletePaymentCard(params) {
    return http.post(DELETE_CARD, params);
  },
  checkDefaultPayment(params) {
    return http.post(DEFAULT_CARD, params);
  },
  getExpired(params) {
    return http.post(EXPIRE_URL, params);
  },
  getPlanDetails(params, cb) {
    http.post(GET_CLIENTPALN, params).then(function (response) {
      cb(response.data);
    });
  },
  getLastSelectedPlan(params, cb) {
    http
      .post(GET_LAST_SELECTED_PLAN, params)
      .then(function (response) {
        cb(response.data);
      })
      .catch(function (error) {
        cb(error);
      });
  },
  applyCouponCode(params) {
    return http.post(APPLY_COUPON_CODE, params);
  },
  setLastSelectedPlan(params) {
    return http.post(SAVE_LAST_SELECTED_PLAN, params);
    /* http.post(SAVE_LAST_SELECTED_PLAN, params).then(function (response) {
      alert(1)
      cb(response.data)
    }).catch(function (error) {
      alert(2)
      cb(error)
    }) */
  },
  setNewAuthToken(params) {
    return http.post(NEW_AUTH_TOKEN, params);
  },
  getCurrentPlanDetails(params, cb) {
    http.get(CURRENT_PLAN_DETAILS, params).then(function (response) {
      cb(response.data);
    });
  },
  cancelSubScription(params) {
    return http.post(CANCEL_SUBSCRIPTION, params);
  },
  restartSubscription(params) {
    return http.post(RESTART_SUBSCRIPTION, params);
  },
  getSavedCards(params) {
    return http.post(GET_SAVED_CARDS, params);
  },
};
